import React from 'react';

const Vue_activated = () => {
  return (
    <div>
      <h1>Vue_activated Component</h1>
      <p>This is the Vue_activated tutorial page.</p>
    </div>
  );
}

export default Vue_activated;
